import { inject_rb_form } from '../form';

const main_view = {
    template: require('./view.html'),
};
const state_config = inject_rb_form({
    url: '/mission_win_rate',
    reloadOnSearch: false,
    data: {
        title: 'Mission Win Rate',
    },
    views: {
        '': main_view,
    },
});
export default state_config;
